import React from 'react';
import i18next from "i18next"
import {  NavbarBrand  } from 'reactstrap';
import { setScreen, appScreens, displayDialogQrcodeLinkToApp } from './store/appNavigation/actions';
import {connect} from 'react-redux'
import { createAnId } from './EIVCommons';

class EIVHeader extends React.Component {
  constructor(props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.closeOnOutsideClick = this.closeOnOutsideClick.bind(this);
    this.closeOnEscape = this.closeOnEscape.bind(this);
    this.headerRef = React.createRef();
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar() {
    this.setState({ collapsed: !this.state.collapsed });
  }

  // Bootstrap 5 braucht fuer sein Dropdown eine andere Markup-Struktur und laedt dafuer
  // Popper nach. Das Menue hier hat drei Eintraege - der Zustand lag ohnehin schon in
  // der Komponente, er wurde beim Rendern nur nie ausgewertet.
  componentDidMount() {
    document.addEventListener('click', this.closeOnOutsideClick, true);
    document.addEventListener('keydown', this.closeOnEscape);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.closeOnOutsideClick, true);
    document.removeEventListener('keydown', this.closeOnEscape);
  }
  closeMenu() {
    if (!this.state.collapsed) this.setState({ collapsed: true });
  }

  closeOnOutsideClick(event) {
    if (this.state.collapsed) return;
    if (this.headerRef.current && !this.headerRef.current.contains(event.target)) this.closeMenu();
  }

  closeOnEscape(event) {
    if (event.key === 'Escape') this.closeMenu();
  }

  render() {
    const anId = createAnId();
    const title = process.env.REACT_APP_HEADER_TITLE || i18next.t('eiv.header');
    const subTitle = process.env.REACT_APP_HEADER_SUBTITLE  || i18next.t('eiv.header.subtitile');
    return (
      
        <header className="navbar fixed-top bg-body" ref={this.headerRef} >
          <button onClick={this.toggleNavbar} className="me-2 navbar-toggler" type="button" aria-controls="navbarNavDropdown" aria-expanded={!this.state.collapsed} aria-label="Menü öffnen">
            <span className="navbar-toggler-icon"></span>
          </button>
          <NavbarBrand onClick={e => this.props.setScreen(appScreens.startPage)} className="me-auto">
          <div className="ms-2 d-inline-block">
                <div className="mb-0 mt-0 h5">{title}</div>
                <div className="h6 fw-light pt-0">{subTitle}</div>
           </div>
          </NavbarBrand>
          <div id="navbarNavDropdown">
          <div className={"dropdown-menu dropdown-menu-start" + (this.state.collapsed ? "" : " show")} aria-labelledby={anId}>
            <div className="dropdown-item clickableValue"  onClick={e => { this.closeMenu(); this.props.setScreen(appScreens.startPage); }}>
              Startseite
            </div>
            <div className="dropdown-item clickableValue"  onClick={e => { this.closeMenu(); this.props.setScreen(appScreens.veranstalterPage); }}>
            Punktemeldung
            </div>
            <div className="dropdown-divider"></div>
            {/* Echter Link mit **relativer** Adresse: so oeffnet er auf Dev, Test und Produktiv
                jeweils die Fassung, die zu dieser App gehoert. Die beiden Eintraege darunter
                zeigen absolut auf punkte.eiv-fobi.de - von der Testinstanz landet man damit auf
                der Produktivseite. Eine andere Baustelle, hier nicht mitgeaendert. */}
            <a className="dropdown-item" href="kurzanleitung/index.html"
              target="_blank" rel="noopener noreferrer" onClick={this.closeMenu}>
              Hilfe / Kurzanleitung
            </a>
            <div className="dropdown-item clickableValue"  onClick={e => { this.closeMenu(); window.open('https://punkte.eiv-fobi.de/datenschutz.html', '_blank'); }}>
              Datenschutz
             </div>
            <div className="dropdown-item clickableValue"  onClick={e => { this.closeMenu(); window.open('https://punkte.eiv-fobi.de/impressum.html', '_blank'); }}>
              Impressum
             </div>
            <div className="dropdown-divider"></div>
            <div className="dropdown-item clickableValue"  onClick={e => { this.closeMenu(); this.props.openModalQRCodeZurApp(); }}>
            Link zur App anzeigen
            </div>
          </div>
          </div>
        </header>
      
    );
  }
}
const mapDispatchToProps = dispatch => {
  return {
    setScreen : (screen) => dispatch(setScreen(screen)),
    openModalQRCodeZurApp : () => dispatch(displayDialogQrcodeLinkToApp(true))
	}
};
export default connect(null, mapDispatchToProps)(EIVHeader)